export default "__VITE_ASSET__CBRgpCf___"